/**
 * Submodule to hold the product data
 * --- Usage Setup Example ---
 * const formObject = $('#myForm');
 * const sku = 123456789;
 * const partNumber = 987654321;
 * const myProductObject = addToCartProductObject.constructProductObject(formObject, sku, partNumber);
 * --- Post setup Example ---
 * console.log(myProductObject)
 */
 define([], function() {
    let addToCartProductObject = {
        productObject: null,
        constructProductObject: function(formObject, sku, partNumber) {
            this.productObject = {
                minQty: formObject.find('.minQuantity').val(),
                maxQty: formObject.find('.maxQuantity').val(),
                SKU: sku,
                productPartNumber: partNumber,
                contractIdentifier: $('#catalogType_'+partNumber).val(),
                quantity: formObject.find('.product-quick-buy-txt .form-control').val(),
            };
            return this.productObject;
        },
    };
    return addToCartProductObject;
});



// WEBPACK FOOTER //
// ./js/search/addToCartProductObject.js